import React, { useCallback, useEffect, useMemo, useState } from 'react';
// import { Row, Col } from 'antd';
import moment from 'moment';
// import { EditOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import { getApi } from 'redux/sagas/getApiDataSaga';
import { SERVER_IP } from 'assets/Config';
import HighlightComponent from 'components/HighlightComponent';
import { resetApiStatus } from 'redux/reducers/globals/globalActions';
import { convertToIndianRupees, formQueryStringFromObject, generatePagination, getWhatsAppUrl } from 'helpers';
import { API_STATUS, DATE_FORMAT } from 'constants/app-constants';
import OutstandingListPresentational from './outstanding-list-presentational';
import { Button, Col, Image, Row } from 'antd';
import { FaMoneyCheck } from 'react-icons/fa';
import MaleSVG from '../../../../assets/images/male.svg';
import FemaleSVG from '../../../../assets/images/female.svg';
import dayjs from 'dayjs';
import { useI18n } from 'hooks/useI18n';

const initialPageSize = 10;
const initialPageSizeOptions = [10, 15, 20];

const OutstandingListFunctional = React.memo(({ reportType, month }) => {
	const outstandingRedux = useSelector((state) => state.outstandingRedux);
	const globalRedux = useSelector((state) => state.globalRedux);
	const [paynowAddModal, setPaynowAddModal] = useState(false);
	const [paynowDetails, setPaynowDetails] = useState(null);
	const [isInActiveCheck, setIsInActiveCheck] = useState(false);
	console.log('🚀 ~ OutstandingListFunctional ~ paynowDetails:', paynowDetails);
	const [selectedRowKeys, setSelectedRowKeys] = useState([]);
	const dispatch = useDispatch();
	const { t } = useI18n();

	const [searchKey, setSearchKey] = useState('');
	const [tableData, setTableData] = useState(outstandingRedux.outstanding);
	const [editPayment, setEditPayment] = useState(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(initialPageSize);
	const [type] = useState('membership');

	const getOutstanding = useCallback(
		(type) => {
			const queryParams = {
				branchId: globalRedux?.selectedBranch?.id,
				paymentType: type,
				outstanding: true,
				isCustomerActive: !isInActiveCheck
			};

			// Only add month parameter if month is valid
			if (month && dayjs(month).isValid()) {
				queryParams.month = dayjs(month).format(DATE_FORMAT.MM_YYYY);
			}

			const string = formQueryStringFromObject(queryParams);
			let url = `${SERVER_IP}api/payments?${string}`;
			dispatch(getApi('GET_OUTSTANDING', url));
		},
		[dispatch, globalRedux?.selectedBranch?.id, isInActiveCheck, month]
	);

	useEffect(() => {
		getOutstanding(reportType);
	}, [getOutstanding, reportType]);

	useEffect(() => {
		generatePagination(tableData);
	}, [tableData]);

	useEffect(() => {
		let doIt = false;
		if (globalRedux.apiStatus.DELETE_PAYMENT === 'SUCCESS') {
			dispatch(resetApiStatus('DELETE_PAYMENT'));
			setSelectedRowKeys([]);
			doIt = true;
		}
		if (doIt) {
			getOutstanding(type);
		}
	}, [globalRedux.apiStatus.DELETE_PAYMENT, dispatch, getOutstanding, type]);

	useEffect(() => {
		setTableData(outstandingRedux.outstanding);
	}, [outstandingRedux.outstanding]);

	const handlePaynow = (record) => {
		const newRecord = { ...record };
		newRecord.amount = newRecord?.balance;
		newRecord.balance = 0;
		newRecord.paid = 0;
		newRecord.paidOn = moment();
		newRecord.paymentFor = reportType;
		setPaynowDetails(newRecord);
		setPaynowAddModal(true);
		console.log({ paynowAddModal, paynowDetails, record });
	};

	const filteredData = useMemo(() => {
		if (searchKey === '') {
			return tableData;
		}
		return tableData.filter((outstanding) => {
			return (
				(outstanding?.customerName || '')?.toLowerCase().includes(searchKey.toLowerCase()) ||
				(outstanding?.mobile || '')?.toLowerCase().includes(searchKey.toLowerCase()) ||
				(outstanding?.email || '')?.toLowerCase().includes(searchKey.toLowerCase()) ||
				(outstanding?.address || '')?.toString().toLowerCase().includes(searchKey.toLowerCase())
				// (outstanding?.outstandingBalance || '')?.toString().toLowerCase().includes(searchKey.toLowerCase())
			);
		});
	}, [tableData, searchKey]);

	// const handleDrawer = (rowData) => {
	// 	setEditPayment(rowData);
	// 	setPaynowAddModal(true);
	// };

	const handleAddPayment = () => {
		setEditPayment(null);
		setPaynowAddModal(true);
	};

	const columns = {
		product: [
			{
				title: t('outstanding.columns.number'),
				dataIndex: 'outstandingNumber',
				key: 'outstandingNumber',
				render: (value, record, index) => <div>{index + 1}</div>,
			},
			{
				title: t('outstanding.columns.pic'),
				dataIndex: 'customer',
				key: 'customer',
				width: 50,
				fixed: 'left',
				render: (value, record) => {
					return (
						<Row align={'middle'}>
							<Col
								style={{
									paddingRight: '10px',
								}}>
								{record?.image?.[0]?.url ? (
									<Image
										src={SERVER_IP + record?.image?.[0]?.url}
										alt="Avatar"
										style={{ width: '40px', height: '40px', borderRadius: 5 }}
										fallback={record?.gender === 'male' ? MaleSVG : FemaleSVG}
									/>
								) : (
									<img
										src={record?.gender === 'male' ? MaleSVG : FemaleSVG}
										alt="Avatar"
										style={{ width: '40px', height: '40px', borderRadius: 5 }}
									/>
								)}
							</Col>
						</Row>
					);
				},
			},
			{
				title: t('outstanding.columns.customer_name'),
				dataIndex: 'customerName',
				width: '13%',
				fixed: 'left',
				sorter: (a, b) => a?.customerName?.localeCompare(b?.customerName),
				render: (value, record) => {
					return (
						<Row align={'middle'}>
							<div style={{ fontWeight: 'bold' }}>
								<HighlightComponent
									highlightClassName="highlightClass"
									searchWords={[searchKey]}
									autoEscape={true}
									textToHighlight={value || '-'}
								/>
							</div>
						</Row>
					);
				},
			},
			{
				title: t('outstanding.columns.mobile'),
				dataIndex: 'mobile',
				width: '15%',
				render: (value, record) => (
					// eslint-disable-next-line
					value !== null 
					?
					<a
						style={{ fontWeight: 'bold' }}
						href={getWhatsAppUrl(
							value,
							`
Hi *${record?.customerName}*,

We hope you're doing well. Our records indicate an outstanding amount of ${
								record?.balance || 0
							} on your account. To avoid any service interruptions, please make your payment at your earliest convenience.

Thank you for your prompt attention to this matter.

Best regards,
*${globalRedux?.selectedBranch?.branchName}* Team`
						)}
						rel="nofollow noopener noreferrer"
						target="_blank">
						<HighlightComponent highlightClassName="highlightClass" searchWords={[searchKey]} autoEscape={true} textToHighlight={value} />
					</a>
					:
					<p></p>
				),
			},
			{
				title: t('outstanding.columns.product'),
				dataIndex: 'productName',
				width: '15%',
				render: (value) => (value || '-') && <span className="membership-button">{value || '-'}</span>,
			},
			{
				title: t('outstanding.columns.paid_on'),
				dataIndex: 'paidOn',
				align: 'left',
				width: '10%',
				render: (value) => (
					<HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={moment(value).format(DATE_FORMAT.DD_MM_YYYY)} />
				),
			},
			{
				title: t('outstanding.columns.amount_total'),
				dataIndex: 'amount',
				align: 'right',
				width: '15%',
				render: (value) => <HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				,
			},
			{
				title: t('outstanding.columns.amount_paid'),
				dataIndex: 'paid',
				align: 'right',
				width: '15%',
				render: (value) => <HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				,
			},
			{
				title: t('outstanding.columns.balance'),
				dataIndex: 'balance',
				align: 'right',
				render: (value) => (
					<div
						style={{
							color: 'red',
							fontWeight: 'bold',
						}}>
						<HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				
					</div>
				),
			},
			// {
			// 	title: 'Remarks',
			// 	dataIndex: 'remarks',
			// 	align: 'left',
			// 	render: (value) => <HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={(value || '-')?.toString()} />,
			// },
			{
				title: t('outstanding.columns.action'),
				dataIndex: 'id',
				align: 'left',
				width: '10%',
				render: (value, row, index) => {
					return (
						<div
							style={{
								display: 'flex',
								gap: 5,
							}}>
							<Button
								title="Pay now"
								type="primary"
								style={{ background: '#3a9f10' }}
								icon={<FaMoneyCheck />}
								onClick={() => handlePaynow(row)}
								disabled={row.isConvertedToCustomer}
							/>
						</div>
					);
				},
			},
		],
		membership: [
			{
				title: t('outstanding.columns.number'),
				dataIndex: 'outstandingNumber',
				key: 'outstandingNumber',
				width: '5%',
				render: (value, record, index) => <div>{index + 1}</div>,
			},
			{
				title: t('outstanding.columns.pic'),
				dataIndex: 'customer',
				key: 'customer',
				width: 50,
				fixed: 'left',
				render: (value, record) => {
					return (
						<Row align={'middle'}>
							<Col
								style={{
									paddingRight: '10px',
								}}>
								{record?.image?.[0]?.url ? (
									<Image
										src={SERVER_IP + record?.image?.[0]?.url}
										alt="Avatar"
										style={{ width: '40px', height: '40px', borderRadius: 5 }}
									/>
								) : (
									<img
										src={record?.gender === 'male' ? MaleSVG : FemaleSVG}
										alt="Avatar"
										style={{ width: '40px', height: '40px', borderRadius: 5 }}
									/>
								)}
							</Col>
						</Row>
					);
				},
			},
			{
				title: t('outstanding.columns.customer_name'),
				dataIndex: 'customerName',
				width: '13%',
				fixed: 'left',
				sorter: (a, b) => a?.customerName?.localeCompare(b?.customerName),
				render: (value, record) => {
					return (
						<Row align={'middle'}>
							<div style={{ fontWeight: 'bold' }}>
								<HighlightComponent
									highlightClassName="highlightClass"
									searchWords={[searchKey]}
									autoEscape={true}
									textToHighlight={value || '-'}
								/>
							</div>
						</Row>
					);
				},
			},
			{
				title: t('outstanding.columns.mobile'),
				dataIndex: 'mobile',
				width: '15%',
				render: (value, record) => (
					// eslint-disable-next-line
					value !== null 
					?
					<a
						style={{ fontWeight: 'bold' }}
						href={getWhatsAppUrl(
							value,
							`
Hi *${record?.customerName}*,

We hope you're doing well. Our records indicate an outstanding amount of ${
								record?.balance || 0
							} on your account. To avoid any service interruptions, please make your payment at your earliest convenience.

Thank you for your prompt attention to this matter.

Best regards,
*${globalRedux?.selectedBranch?.branchName}* Team`
						)}
						rel="nofollow noopener noreferrer"
						target="_blank">
						<HighlightComponent highlightClassName="highlightClass" searchWords={[searchKey]} autoEscape={true} textToHighlight={value} />
					</a>
					:
					<p></p>
				),
			},
			{
				title: t('outstanding.columns.service'),
				dataIndex: 'serviceName',
				width: '13%',
				render: (value) => (value || '-') && <span className="membership-button">{value}</span>,
			},
			{
				title: t('outstanding.columns.membership'),
				dataIndex: 'membershipName',
				align: 'left',
				width: '12%',
				render: (value) => (value || '-') && <span className="membership-button">{value}</span>,
			},
			{
				title: t('outstanding.columns.joining_date'),
				dataIndex: 'joiningDate',
				align: 'left',
				width: '10%',
				render: (value) => (
					<HighlightComponent
						searchWords={[searchKey]}
						autoEscape={true}
						textToHighlight={moment(value).format(DATE_FORMAT.DD_MM_YYYY)}
					/>
				),
			},
			{
				title: t('outstanding.columns.amount_total'),
				dataIndex: 'amount',
				align: 'right',
				width: '16%',
				render: (value) => (
					<HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				),
			},
			{
				title: t('outstanding.columns.amount_paid'),
				dataIndex: 'paid',
				align: 'right',
				width: '16%',
				render: (value) => (
					<HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				),
			},
			{
				title: t('outstanding.columns.balance'),
				dataIndex: 'balance',
				align: 'right',
				width: '7%',
				render: (value) => (
					<div
						style={{
							color: 'red',
							fontWeight: 'bold',
						}}>
						<HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
					</div>
				),
			},
			// {
			// 	title: 'Remarks',
			// 	dataIndex: 'remarks',
			// 	align: 'left',
			// 	width: '15%',
			// 	render: (value) => <HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={(value || '-')?.toString()} />,
			// },
			{
				title: t('outstanding.columns.action'),
				dataIndex: 'id',
				align: 'left',
				width: '5%',
				render: (value, row, index) => {
					return (
						<div
							style={{
								display: 'flex',
								gap: 5,
							}}>
							<Button
								title="Pay now"
								type="primary"
								style={{ background: '#3a9f10' }}
								icon={<FaMoneyCheck />}
								onClick={() => handlePaynow(row)}
								disabled={row.isConvertedToCustomer}
							/>
						</div>
					);
				},
			},
		],
		personalTraining: [
			{
				title: t('outstanding.columns.number'),
				dataIndex: 'outstandingNumber',
				key: 'outstandingNumber',
				render: (value, record, index) => <div>{index + 1}</div>,
			},
			{
				title: t('outstanding.columns.pic'),
				dataIndex: 'customer',
				key: 'customer',
				width: 50,
				fixed: 'left',
				render: (value, record) => {
					return (
						<Row align={'middle'}>
							<Col
								style={{
									paddingRight: '10px',
								}}>
								{record?.image?.[0]?.url ? (
									<Image
										src={SERVER_IP + record?.image?.[0]?.url}
										alt="Avatar"
										style={{ width: '40px', height: '40px', borderRadius: 5 }}
									/>
								) : (
									<img
										src={record?.gender === 'male' ? MaleSVG : FemaleSVG}
										alt="Avatar"
										style={{ width: '40px', height: '40px', borderRadius: 5 }}
									/>
								)}
							</Col>
						</Row>
					);
				},
			},
			{
				title: t('outstanding.columns.customer_name'),
				dataIndex: 'customerName',
				width: '13%',
				fixed: 'left',
				sorter: (a, b) => a?.customerName?.localeCompare(b?.customerName),
				render: (value, record) => {
					return (
						<Row align={'middle'}>
							<div style={{ fontWeight: 'bold' }}>
								<HighlightComponent
									highlightClassName="highlightClass"
									searchWords={[searchKey]}
									autoEscape={true}
									textToHighlight={value || '-'}
								/>
							</div>
						</Row>
					);
				},
			},
			{
				title: t('outstanding.columns.mobile'),
				dataIndex: 'mobile',
				width: '15%',
				render: (value, record) => (
					// eslint-disable-next-line
					value !== null 
					?
					<a
						style={{ fontWeight: 'bold' }}
						href={getWhatsAppUrl(
							value,
							`
Hi *${record?.customerName}*,

We hope you're doing well. Our records indicate an outstanding amount of ${
								record?.balance || 0
							} on your account. To avoid any service interruptions, please make your payment at your earliest convenience.

Thank you for your prompt attention to this matter.

Best regards,
*${globalRedux?.selectedBranch?.branchName}* Team`
						)}
						rel="nofollow noopener noreferrer"
						target="_blank">
						<HighlightComponent highlightClassName="highlightClass" searchWords={[searchKey]} autoEscape={true} textToHighlight={value} />
					</a>
					:
					<p></p>
				),
			},
			{
				title: t('outstanding.columns.coach_name'),
				dataIndex: 'coachName',
				width: '15%',
				render: (value) => (value || '-') && <span className="membership-button">{value || '-'}</span>,
			},
			{
				title: t('outstanding.columns.paid_on'),
				dataIndex: 'paidOn',
				align: 'left',
				width: '10%',
				render: (value) => (
					<HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={moment(value).format(DATE_FORMAT.DD_MM_YYYY)} />
				),
			},
			{
				title: t('outstanding.columns.amount_total'),
				dataIndex: 'amount',
				align: 'right',
				width: '15%',
				render: (value) => <HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				,
			},
			{
				title: t('outstanding.columns.amount_paid'),
				dataIndex: 'paid',
				align: 'right',
				width: '15%',
				render: (value) => <HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				,
			},
			{
				title: t('outstanding.columns.balance'),
				dataIndex: 'balance',
				align: 'right',
				render: (value) => (
					<div
						style={{
							color: 'red',
							fontWeight: 'bold',
						}}>
						<HighlightComponent searchWords={[searchKey]} autoEscape={true} textToHighlight={convertToIndianRupees(value || 0)} />
				
					</div>
				),
			},
			{
				title: t('outstanding.columns.action'),
				dataIndex: 'id',
				align: 'left',
				width: '10%',
				render: (value, row, index) => {
					return (
						<div
							style={{
								display: 'flex',
								gap: 5,
							}}>
							<Button
								title="Pay now"
								type="primary"
								style={{ background: '#3a9f10' }}
								icon={<FaMoneyCheck />}
								onClick={() => handlePaynow(row)}
								disabled={row.isConvertedToCustomer}
							/>
						</div>
					);
				},
			},
		],
	};

	const handleTableChange = (currentPage, pageSize) => {
		setCurrentPage(currentPage);
		setPageSize(pageSize);
	};

	const getStartingValue = () => {
		if (currentPage === 1) return 1;
		else {
			return (currentPage - 1) * pageSize + 1;
		}
	};

	const getEndingValue = () => {
		if (currentPage === 1) return tableData.length < pageSize ? tableData.length : pageSize;
		else {
			let end = currentPage * pageSize;
			return end > tableData.length ? tableData.length : end;
		}
	};

	const tableLoading = useMemo(() => globalRedux.apiStatus.GET_OUTSTANDING === API_STATUS.PENDING, [globalRedux.apiStatus]);

	const onSelectChange = (selectedRowKeys) => {
		setSelectedRowKeys(selectedRowKeys);
	};

	const rowSelection = {
		selectedRowKeys,
		onChange: onSelectChange,
		// fixed: true,
	};

	const handleClose = useCallback(() => {
		setPaynowAddModal(false);
		setEditPayment(null);
	}, [setPaynowAddModal, setEditPayment]);

	// const onTypeChange = (type) => {
	// 	setType(type);
	// };

	return (
		<OutstandingListPresentational
			{...{
				filteredData,
				column: columns[reportType],
				tableLoading,
				rowSelection,
				selectedRowKeys,
				handleAddPayment,
				currentPage,
				pageSize,
				initialPageSizeOptions,
				initialPageSize,
				handleTableChange,
				setSearchKey,
				getStartingValue,
				getEndingValue,
				refreshList: () => getOutstanding(reportType),
				editPayment,
				handleClose,
				reportType,
				paynowDetails,
				setPaynowDetails,
				paynowAddModal,
				setPaynowAddModal,
				isInActiveCheck,
				setIsInActiveCheck,
			}}
		/>
	);
});

export default OutstandingListFunctional;
